import clsx from 'clsx'
import update from 'immutability-helper'
import React from 'react'
import {useHistory} from 'react-router-dom'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import {faEye, faSave} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Title from '../components/assessment-header-title'
import SaveAssessment from './SaveAssessment'
import AssessmentConfiguration from './AssessmentConfiguration'

import create, {createPost} from 'helpers/command'
import {validateAssessment} from 'helpers/quiz'



const useStyles = makeStyles(assessmentHeaderStyles)

export default function AssessmentHeader ({context, onSave, onCancel}) {

  const classes = useStyles()
  const history = useHistory()
  const [opened, setOpened] = React.useState(false)
  const [errors, setErrors] = React.useState([])
  const [assessmentErrors, setAssessmentErrors] = React.useState([])

  function handleOpen() { setOpened(true)
  }

  function handleClose() {
    setOpened(false)
  }

  const {link, translate, quizAssessment: assessment, action} = context

  async function handleRetitle(newTitle) {
    if (assessment.title != newTitle && newTitle.length > 0) {
      const [updatedId] = await create('quiz', 'retitleAssessment')({id: assessment.id, newTitle})
      if (updatedId == assessment.id) {
        const quizAssessment = update(context.quizAssessment, {title: {$set: newTitle}})
        context.setState({quizAssessment})
      }
    }
  }

  const isSection = context.sectionId && !context.questionId
  const isQuestion = context.questionId != undefined

  const section = isSection
    ? `${context.sectionId}`
    : isQuestion
      ? `${context.sectionId}/${context.questionId}`
      : ''

  const previewLink = context.sectionName == 'standards'
    ? link({action: 'preview'}, '/:languageId/:role/:page/:assessment/:action')
    : context.sectionName != 'standards-search' ? link({action: 'preview'}) : ''

  function handlePreviewClick () {
    const quizPreviewFrom = context.sectionName == 'standards'
      ? '/:languageId/:role/:page/:assessment/edit/standards'
      : `/:languageId/:role/:page/:assessment/edit/${section}`
    context.setState({quizPreviewFrom, quizPreviewFromQuery: {...context.query}})
  }

  async function handleSaveClick () {

    const {assessmentErrors, questionErrors} = validateAssessment(context.quizQuestions, context)

    const hasErrors = assessmentErrors.length > 0 || questionErrors.length > 0

    if (hasErrors) {
      setAssessmentErrors(assessmentErrors)
      setErrors(questionErrors)
      handleOpen()
    } else {
      const properties = update(assessment.properties, {validated: {$set: true}})
      await createPost('quiz', 'updateAssessmentProperties')({id: assessment.id, properties})
      history.push(link({}, context.quizEditFrom || '/:languageId/:role/:page/assessments', {query: context.quizEditFromQuery}))
    }

  }

  return (
    <Box className={classes.root}>
      <Box className={clsx(classes.title, action)}>
        <Box className="container">
          <Title className="title-control" context={context} onChange={handleRetitle} />
        </Box>
      </Box>
      <AssessmentConfiguration className={classes.configuration} context={context} />
      <Link className={clsx(classes.preview, classes.button)} onClick={handlePreviewClick} to={previewLink}>
        <Box className={clsx("button", "preview", action)}>
          <FontAwesomeIcon className="icon" icon={faEye} />
          <Box className="label">{translate('preview')}</Box>
        </Box>
      </Link>
      <Box className={clsx(classes.close, classes.button)} onClick={handleSaveClick}>
        <Box className={clsx("button", "close")}>
          <FontAwesomeIcon className="icon" icon={faSave} />
          <Box className="label">{translate('finalize')}</Box>
        </Box>
      </Box>
      <SaveAssessment
        isOpen={opened}
        context={context}
        errors={errors}
        assessmentErrors={assessmentErrors}
        onClose={handleClose}
      />
    </Box>
  )
}



function assessmentHeaderStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  return {
    root: {
      display: 'flex',
    },
    configuration: {
      marginRight: 15
    },
    button: {
      flexShrink: 0,
      width: 115,
      height: 35,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      cursor: 'pointer',
      border: 'solid 1px #ccc',
      backgroundColor: '#fff',
      borderRadius: 4,
      textDecoration: 'none',
      '& .button': {
        display: 'flex',
        justifyContent: 'center',
        textDecoration: 'none',
        color: '#69748a',
        '& .icon': {
          fontSize: '15pt',
          margin: '0 2px'
        }
      }
    },
    close: {
      marginLeft: 20
    },
    title: {
      ...verticalCentering,
      flexGrow: 1,
      '& .container': {
        display: 'flex'
      },
      '& .title-control': {
        display: 'flex'
      },
      '& .titlelabel': {
        color: '#69738c',
        fontWeight: 'bold',
        ...verticalCentering
      },
      '& .titleInput' : {
        marginLeft: 10,
        color: '#6b728c',
        cursor: 'text',
        ...verticalCentering
      },
      '& .control': {
        display: 'flex',
        borderBottom: 'solid 1px',
        flexGrow: 1,
      },
      '& .input-wrapper': {
        flexGrow: 1,
        ...verticalCentering
      },
      '& .input': {
        background: 'none',
        border: 'none',
        width: '100%',
        fontSize: '10pt',
        flexGrow: 1,
        '&:focus': {
          outline: 'none'
        }
      },
      '& .addornment': {
        cursor: 'pointer',
        marginTop: -3,
        ...verticalCentering
      },
      '& .icon': {
        marginTop: -2,
        marginLeft: 4,
        fontSize: 9,
        color: '#69748a',
        cursor: 'pointer',
        '&.editing': {
          display: 'none'
        }
      }
    }
  }
}

